import React from 'react';

type Options = {
  /** strana z adresy (`?page=`), od nuly */
  pageIndex: number;
  /** koľko strán má `useInfiniteQ` načítaných (`data.pages.length`) */
  loadedPages: number;
  hasNextPage: boolean;
  /** prvá strana alebo ďalšia práve letí - vtedy sa nič nedočítava */
  isFetching: boolean;
  fetchNextPage: () => unknown;
  setPageIndex: (page: number) => void;
};

/**
 * Dočíta strany `useInfiniteQ` až po tú, ktorá je v adrese.
 *
 * Zoznamy držia stranu v URL (`useUrlFilters`), ale dáta v nekonečnom dotaze,
 * ktorý sa pri obnovení stránky začína od prvej strany. Klik na „ďalej" si
 * ďalšiu stranu dočíta sám, **F5 na `?page=2` nie**: `data.pages[1]` neexistoval
 * a zoznam hlásil „Žiadny podnet nesedí na filtre", hoci podnety tam boli.
 * Dočíta sa postupne, nie skokom - hlasovania stránkujú kurzorom a tretia
 * strana sa bez druhej nedá ani vypýtať.
 *
 * Keď strana z adresy za koncom zoznamu neexistuje (zoznam medzitým
 * skrátil filter alebo archivácia), adresa sa posunie na poslednú stranu,
 * ktorá existuje - inak by visela prázdna strana bez cesty späť.
 */
export const useLoadPagesThrough = ({
  pageIndex,
  loadedPages,
  hasNextPage,
  isFetching,
  fetchNextPage,
  setPageIndex,
}: Options) => {
  React.useEffect(() => {
    if (isFetching || loadedPages === 0 || pageIndex < loadedPages) return;

    if (hasNextPage) {
      fetchNextPage();
      return;
    }

    setPageIndex(loadedPages - 1);
  }, [
    pageIndex,
    loadedPages,
    hasNextPage,
    isFetching,
    fetchNextPage,
    setPageIndex,
  ]);
};
